import React from 'react';
import SkillsTabs from './SkillsTabs';

const Skills = () => {
    return (

        <div id="skills" className="skills-section">
            <h1 className="pageTitle">What I've worked with</h1>
            <SkillsTabs />
        </div>
  );
};

export default Skills;
